import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Validators, FormControl, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@ngx-translate/core';

const _c0 = function (a0) { return { "is-invalid": a0 }; };
function MarketplaceCustomFieldsComponent_div_5_input_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 11);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    const i_r2 = ctx_r7.index;
    const customFieldDynamic_r1 = ctx_r7.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", "customField_" + i_r2)("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c0, (ctx_r3.customFieldsForm.controls[i_r2].dirty || ctx_r3.hasSumbittedForm) && !!ctx_r3.customFieldsForm.controls[i_r2].errors))("formControl", ctx_r3.customFieldsForm.controls[i_r2])("placeholder", customFieldDynamic_r1.DisplayName);
} }
function MarketplaceCustomFieldsComponent_div_5_textarea_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "textarea", 12);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    const i_r2 = ctx_r8.index;
    const customFieldDynamic_r1 = ctx_r8.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", "customField_" + i_r2)("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c0, (ctx_r4.customFieldsForm.controls[i_r2].dirty || ctx_r4.hasSumbittedForm) && !!ctx_r4.customFieldsForm.controls[i_r2].errors))("formControl", ctx_r4.customFieldsForm.controls[i_r2])("placeholder", customFieldDynamic_r1.DisplayName);
} }
function MarketplaceCustomFieldsComponent_div_5_input_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 13);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    const i_r2 = ctx_r9.index;
    const customFieldDynamic_r1 = ctx_r9.$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", "customField_" + i_r2)("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c0, (ctx_r5.customFieldsForm.controls[i_r2].dirty || ctx_r5.hasSumbittedForm) && !!ctx_r5.customFieldsForm.controls[i_r2].errors))("formControl", ctx_r5.customFieldsForm.controls[i_r2])("placeholder", customFieldDynamic_r1.DisplayName);
} }
function MarketplaceCustomFieldsComponent_div_5_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "custom.field.error.required"));
} }
function MarketplaceCustomFieldsComponent_div_5_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ɵngcc0.ɵɵnextContext(2).index;
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3(" ", ɵngcc0.ɵɵpipeBind1(2, 3, "custom.field.error.maxlength"), " (", ctx_r11.customFieldsForm.controls[i_r2].errors.maxlength.actualLength, "/", ctx_r11.customFieldsForm.controls[i_r2].errors.maxlength.requiredLength, ") ");
} }
function MarketplaceCustomFieldsComponent_div_5_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "custom.field.error.validate"));
} }
function MarketplaceCustomFieldsComponent_div_5_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, MarketplaceCustomFieldsComponent_div_5_div_7_div_1_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵtemplate(2, MarketplaceCustomFieldsComponent_div_5_div_7_div_2_Template, 3, 5, "div", 15);
    ɵngcc0.ɵɵtemplate(3, MarketplaceCustomFieldsComponent_div_5_div_7_div_3_Template, 3, 3, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.customFieldsForm.controls[i_r2].errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.customFieldsForm.controls[i_r2].errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.customFieldsForm.controls[i_r2].errors.pattern);
} }
const _c1 = function (a0) { return { "d-flex flex-row align-items-center": a0 }; };
function MarketplaceCustomFieldsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, MarketplaceCustomFieldsComponent_div_5_input_1_Template, 1, 6, "input", 5);
    ɵngcc0.ɵɵtemplate(2, MarketplaceCustomFieldsComponent_div_5_textarea_2_Template, 1, 6, "textarea", 6);
    ɵngcc0.ɵɵtemplate(3, MarketplaceCustomFieldsComponent_div_5_input_3_Template, 1, 6, "input", 7);
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵelementStart(5, "div", 9);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, MarketplaceCustomFieldsComponent_div_5_div_7_Template, 4, 3, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const customFieldDynamic_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c1, customFieldDynamic_r1.FieldType == 2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", customFieldDynamic_r1.FieldType == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", customFieldDynamic_r1.FieldType == 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", customFieldDynamic_r1.FieldType == 2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r0.customFieldsForm.controls[i_r2].value.length, "/", customFieldDynamic_r1.CharacterLimit, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.customFieldsForm.controls[i_r2].dirty || ctx_r0.hasSumbittedForm) && ctx_r0.customFieldsForm.controls[i_r2].errors);
} }
class MarketplaceCustomFieldsComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.customFieldsChange = new EventEmitter();
        this.dynamicFormCustomFields = [];
        this._destroyed$ = new Subject();
    }
    ngOnInit() {
        this.customFieldsForm = this.formBuilder.group({
            customFieldsGroup: this.formBuilder.array([]),
        });
        this._setCustomFields();
        this.customFieldsForm.valueChanges
            .pipe(takeUntil(this._destroyed$), tap(() => this.emitCustomFieldsValues()))
            .subscribe();
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
    emitCustomFieldsValues() {
        let customFields = [];
        for (let index = 0; index < this.dynamicFormCustomFields.length; index++) {
            const control = this.customFieldsForm.get(index.toString());
            if (control) {
                let newCustomField = {
                    customFieldId: this.dynamicFormCustomFields[index].CustomFieldId,
                    customFieldName: this.dynamicFormCustomFields[index].DisplayName,
                    customFieldValue: control.value,
                };
                customFields.push(newCustomField);
            }
        }
        if (!this.customFieldsForm.valid) {
            this.customFieldsChange.emit(undefined);
        }
        else {
            this.customFieldsChange.emit(customFields);
        }
    }
    isRequiredField(fieldIndex) {
        const formField = this.customFieldsForm.controls[fieldIndex];
        if (!formField.validator) {
            return false;
        }
        const validator = formField.validator({});
        return validator && validator.required;
    }
    _setCustomFields() {
        if (this.itemCustomFields) {
            for (let index = 0; index < this.itemCustomFields.length; index++) {
                let currentCustomField = this.itemCustomFields[index];
                this.dynamicFormCustomFields.push(currentCustomField);
                let validators = [];
                if (currentCustomField.FieldType == 2) {
                    if (currentCustomField.IsRequired) {
                        validators.push(Validators.requiredTrue);
                    }
                }
                else {
                    if (currentCustomField.IsRequired) {
                        validators.push(Validators.required);
                    }
                    if (currentCustomField.CharacterLimit > 0) {
                        validators.push(Validators.maxLength(currentCustomField.CharacterLimit));
                    }
                    if (currentCustomField.ValidationRegEx != '') {
                        validators.push(Validators.pattern(currentCustomField.ValidationRegEx));
                    }
                }
                this.customFieldsForm.addControl(index.toString(), new FormControl('', validators));
            }
        }
        this.emitCustomFieldsValues();
    }
}
MarketplaceCustomFieldsComponent.ɵfac = function MarketplaceCustomFieldsComponent_Factory(t) { return new (t || MarketplaceCustomFieldsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder)); };
MarketplaceCustomFieldsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MarketplaceCustomFieldsComponent, selectors: [["fgbcl-marketplace-custom-fields"]], inputs: { itemCustomFields: "itemCustomFields", hasSumbittedForm: "hasSumbittedForm" }, outputs: { customFieldsChange: "customFieldsChange" }, decls: 6, vars: 5, consts: [[1, "custom-field-title", "mb-3", "mt-2"], [1, "pl-0", "pr-0", 3, "formGroup"], [1, "row", "mb-lg-2"], ["class", "col-12 col-lg-6 mb-3 mb-lg-0", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "col-12", "col-lg-6", "mb-3", "mb-lg-0", 3, "ngClass"], ["class", "custom-field-form form-control field", "type", "text", 3, "id", "ngClass", "formControl", "placeholder", 4, "ngIf"], ["class", "field", "type", "text", 3, "id", "ngClass", "formControl", "placeholder", 4, "ngIf"], ["class", "field ml-2", "type", "checkbox", 3, "id", "ngClass", "formControl", "placeholder", 4, "ngIf"], [1, "float-right"], [1, "text-info", "font-size-12", "mt-2"], ["class", "error-messages alert-danger text-left", 4, "ngIf"], ["type", "text", 1, "custom-field-form", "form-control", "field", 3, "id", "ngClass", "formControl", "placeholder"], ["type", "text", 1, "field", 3, "id", "ngClass", "formControl", "placeholder"], ["type", "checkbox", 1, "field", "ml-2", 3, "id", "ngClass", "formControl", "placeholder"], [1, "error-messages", "alert-danger", "text-left"], [4, "ngIf"]], template: function MarketplaceCustomFieldsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "form", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtemplate(5, MarketplaceCustomFieldsComponent_div_5_Template, 8, 9, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 3, "custom.field.title"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.customFieldsForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.dynamicFormCustomFields);
    } }, directives: [ɵngcc1.ɵangular_packages_forms_forms_ba, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgForOf, ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlDirective, ɵngcc1.CheckboxControlValueAccessor], pipes: [ɵngcc3.TranslatePipe], styles: [".alert-danger[_ngcontent-%COMP%]{float:left!important}"] });
MarketplaceCustomFieldsComponent.ctorParameters = () => [
    { type: FormBuilder }
];
MarketplaceCustomFieldsComponent.propDecorators = {
    itemCustomFields: [{ type: Input }],
    hasSumbittedForm: [{ type: Input }],
    customFieldsChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceCustomFieldsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-marketplace-custom-fields',
                template: "<div class=\"custom-field-title mb-3 mt-2\">{{ 'custom.field.title' | translate }}</div>\r\n<form [formGroup]=\"customFieldsForm\" class=\"pl-0 pr-0\">\r\n  <div class=\"row mb-lg-2\">\r\n    <div\r\n      *ngFor=\"let customFieldDynamic of dynamicFormCustomFields; let i = index\"\r\n      class=\"col-12 col-lg-6 mb-3 mb-lg-0\"\r\n      [ngClass]=\"{ 'd-flex flex-row align-items-center': customFieldDynamic.FieldType == 2 }\"\r\n    >\r\n      <!--TextBox-->\r\n      <input\r\n        *ngIf=\"customFieldDynamic.FieldType == 0\"\r\n        [id]=\"'customField_' + i\"\r\n        class=\"custom-field-form form-control field\"\r\n        type=\"text\"\r\n        [ngClass]=\"{\r\n          'is-invalid': (customFieldsForm.controls[i].dirty || hasSumbittedForm) && !!customFieldsForm.controls[i].errors\r\n        }\"\r\n        [formControl]=\"customFieldsForm.controls[i]\"\r\n        [placeholder]=\"customFieldDynamic.DisplayName\"\r\n      />\r\n\r\n      <!--Multiline TextBox-->\r\n      <textarea\r\n        *ngIf=\"customFieldDynamic.FieldType == 1\"\r\n        class=\"field\"\r\n        type=\"text\"\r\n        [id]=\"'customField_' + i\"\r\n        [ngClass]=\"{\r\n          'is-invalid': (customFieldsForm.controls[i].dirty || hasSumbittedForm) && !!customFieldsForm.controls[i].errors\r\n        }\"\r\n        [formControl]=\"customFieldsForm.controls[i]\"\r\n        [placeholder]=\"customFieldDynamic.DisplayName\"\r\n      ></textarea>\r\n\r\n      <!--Checkbox-->\r\n      <input\r\n        *ngIf=\"customFieldDynamic.FieldType == 2\"\r\n        class=\"field ml-2\"\r\n        type=\"checkbox\"\r\n        [id]=\"'customField_' + i\"\r\n        [ngClass]=\"{\r\n          'is-invalid': (customFieldsForm.controls[i].dirty || hasSumbittedForm) && !!customFieldsForm.controls[i].errors\r\n        }\"\r\n        [formControl]=\"customFieldsForm.controls[i]\"\r\n        [placeholder]=\"customFieldDynamic.DisplayName\"\r\n      />\r\n      <div class=\"float-right\">\r\n        <div class=\"text-info font-size-12 mt-2\">\r\n          {{ customFieldsForm.controls[i].value.length }}/{{ customFieldDynamic.CharacterLimit }}\r\n        </div>\r\n      </div>\r\n\r\n      <div\r\n        class=\"error-messages alert-danger text-left\"\r\n        *ngIf=\"(customFieldsForm.controls[i].dirty || hasSumbittedForm) && customFieldsForm.controls[i].errors\"\r\n      >\r\n        <div *ngIf=\"customFieldsForm.controls[i].errors!.required\">{{ 'custom.field.error.required' | translate }}</div>\r\n        <div *ngIf=\"customFieldsForm.controls[i].errors!.maxlength!\">\r\n          {{ 'custom.field.error.maxlength' | translate }} ({{ customFieldsForm.controls[i].errors!.maxlength.actualLength }}/{{\r\n            customFieldsForm.controls[i].errors!.maxlength.requiredLength\r\n          }})\r\n        </div>\r\n        <div *ngIf=\"customFieldsForm.controls[i].errors!.pattern\">{{ 'custom.field.error.validate' | translate }}</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n",
                styles: [".alert-danger{float:left!important}"]
            }]
    }], function () { return [{ type: ɵngcc1.FormBuilder }]; }, { customFieldsChange: [{
            type: Output
        }], itemCustomFields: [{
            type: Input
        }], hasSumbittedForm: [{
            type: Input
        }] }); })();

class MarketplaceCustomFieldsModule {
}
MarketplaceCustomFieldsModule.ɵfac = function MarketplaceCustomFieldsModule_Factory(t) { return new (t || MarketplaceCustomFieldsModule)(); };
MarketplaceCustomFieldsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MarketplaceCustomFieldsModule });
MarketplaceCustomFieldsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MarketplaceCustomFieldsModule, { declarations: function () { return [MarketplaceCustomFieldsComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule, ɵngcc3.TranslateModule]; }, exports: function () { return [MarketplaceCustomFieldsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceCustomFieldsModule, [{
        type: NgModule,
        args: [{
                declarations: [MarketplaceCustomFieldsComponent],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [MarketplaceCustomFieldsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MarketplaceCustomFieldsComponent, MarketplaceCustomFieldsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-marketplace-marketplace-details-marketplace-custom-fields.js.map